import React from 'react';
import { Link } from 'react-router-dom'
import blog3 from '../../images/blog-details/comments-author/img-1.jpg'
import blog4 from '../../images/blog-details/comments-author/img-2.jpg'
import blog5 from '../../images/blog-details/comments-author/img-3.jpg'
import blog6 from '../../images/blog-details/author.webp'
import gl1 from '../../images/blog/img-1.jpg'
import gl2 from '../../images/blog/img-2.jpg'
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom'
import BlogSidebar from '../BlogSidebar/BlogSidebar.js'

const BlogSingle = (props) => {

    const { slug } = useParams()

    const BlogDetails = blogs.find(item => item.slug === slug)

    const submitHandler = (e) => {
        e.preventDefault()
    }
    const SITE_URL = 'https://pharmacyfreedomfund.com';
    const blogUrl = `${SITE_URL}/newsroom/${BlogDetails.slug}`;
    const imageUrl = (BlogDetails.blogSingleImg || '').toString().startsWith('http')
        ? BlogDetails.blogSingleImg
        : `${SITE_URL}${BlogDetails.blogSingleImg}`;

    return (
        <section className="wpo-blog-single-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-8 col-12 ${props.blRight}`}>
                        <div className="wpo-blog-content">
                            <div className="post format-standard-image">
                                <div className="entry-media">
                                    <img src={BlogDetails.blogSingleImg} alt="" />
                                </div>
                                <div className="entry-meta">
                                    <ul>
                                        <li><i className="fi flaticon-user"></i> By <Link to={`/newsroom/${BlogDetails.slug}`}>{BlogDetails.author}</Link> </li>
                                        <li><i className="fi flaticon-comment-white-oval-bubble"></i> Comments {BlogDetails.comment}</li>
                                        <li><i className="fi flaticon-calendar"></i> {BlogDetails.create_at}</li>
                                    </ul>
                                </div>
                                <h2>{BlogDetails.title2}</h2>
                                <p>{BlogDetails.detailDescription2}</p>
                                <blockquote>
                                    {BlogDetails.blockQuote}
                                </blockquote>
                                <p>{BlogDetails.detailDescription}</p>

                            </div>

                            <div className="tag-share clearfix">
                                <div className="tag">
                                    <span>Tags: </span>
                                    <ul>
                                        <li>{BlogDetails.tag}</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="tag-share-s2 clearfix">
                                <div className="tag">
                                    <span>Share: </span>
                                    <ul>
                                        <li>
                                            <a
                                                href={`https://www.facebook.com/sharer/sharer.php?u=${blogUrl}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Facebook
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://twitter.com/intent/tweet?url=${blogUrl}&text=${encodeURIComponent(BlogDetails.title2)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Twitter
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://www.linkedin.com/shareArticle?mini=true&url=${blogUrl}&title=${encodeURIComponent(BlogDetails.title2)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                LinkedIn
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={`https://pinterest.com/pin/create/button/?url=${blogUrl}&media=${imageUrl}&description=${encodeURIComponent(BlogDetails.description)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Pinterest
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="author-box">
                                <div className="author-avatar">
                                    <Link to={`/newsroom/${BlogDetails.slug}`} target="_blank"><img src={blog6} alt="" /></Link>
                                </div>
                                <div className="author-content">
                                    <Link to={`/newsroom/${BlogDetails.slug}`} className="author-name">Author: {BlogDetails.author}</Link>
                                    <p>
                                        {BlogDetails.author} is committed to transforming community healthcare by funding and supporting independent pharmacies. With a focus on access, innovation, and impact, we help pharmacy owners grow their business while improving local health outcomes across underserved regions.
                                    </p>
                                </div>
                            </div>
                        </div >
                    </div >
                    <BlogSidebar blLeft={props.blLeft} />
                </div >
            </div >
        </section >
    )

}

export default BlogSingle;
